import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import EditorFilterSelectBreadcrumbs from './EditorFilterSelectBreadcrumbs';
import EditorFilterSelectStepText from './EditorFilterSelectStepText';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorFilterSelectNav = () => {
  const {
    isFieldSelectMode
  } = useContext(SegmentationFiltersInstanceContext);
  if (!isFieldSelectMode) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    marginBlock: "100",
    as: "div",
    children: [/*#__PURE__*/_jsx(EditorFilterSelectStepText, {}), /*#__PURE__*/_jsx(EditorFilterSelectBreadcrumbs, {})]
  });
};
export default EditorFilterSelectNav;